import {
  Box,
  Button,
  ButtonAppearance,
  ButtonProps,
  ButtonSize,
  Icon,
  IconStyled,
  TextFieldStyled,
} from '@bechtel/gds';
import { FC } from 'react';
import styled, { css } from 'styled-components';

export const ForemanWorklistStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  position: relative;
  overflow-y: auto;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radii[300]};
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.2),
    0 2px 1px -1px rgba(0, 0, 0, 0.12),
    0 1px 1px 0 rgba(0, 0, 0, 0.14);
`;

export const WorklistHeaderStyled = styled(Box).attrs({
  py: { sm: '400' },
  px: { sm: '500' },
})`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
`;

export const WorklistBodyStyled = styled(Box)`
  overflow-y: auto;
  height: 100%;
`;

export const TabListStyled = styled(Box).attrs({ mb: { sm: '100' }, flexShrink: { sm: '0' } })`
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.2),
    0 2px 1px -1px rgba(0, 0, 0, 0.12),
    0 1px 1px 0 rgba(0, 0, 0, 0.14);
`;
export interface TabButtonProps extends ButtonProps {
  selected: boolean;
}

export const TabButtonStyled = styled(Button as FC<TabButtonProps>).attrs({
  appearance: ButtonAppearance.TERTIARY,
  size: ButtonSize.LARGE,
})`
  border: none;
  border-radius: 0;
  position: relative;
  opacity: 0.5;
  &:focus {
    border-color: transparent;
    box-shadow: none;
  }
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.grey[1000]};
    font-size: ${theme.fontSizes[400]};
    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 5px;
      background-color: ${theme.colors.blue[700]};
      opacity: 0;
    }
  `};
  ${(props) =>
    props.selected &&
    css`
      font-weight: ${props.theme.fontWeights[600]};
      opacity: 1;
      &::after {
        opacity: 1;
      }
    `};
`;

export const ListSelectionStyled = styled.label`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  cursor: pointer;
  display: flex;
  flex-direction: row;
  padding: ${({ theme }) => theme.spacings[500]};
  flex-shrink: 0;
  flex-grow: 1;
  &:hover {
    background-color: ${({ theme }) => theme.colors.grey[100]};
  }
`;

export const ListSelectionHeadingStyled = styled(ListSelectionStyled)`
  background-color: ${({ theme }) => theme.colors.grey[100]};
`;

export const CommodityGroupHeaderStyled = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.grey[100]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.spacings[400]} ${theme.spacings[500]}`};
  flex-shrink: 0;
  &:hover {
    background-color: ${({ theme }) => theme.colors.grey[200]};
  }
`;

export const MilestoneListStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  border-right: 1px solid ${({ theme }) => theme.colors.grey[200]};
  width: 165px;
  overflow-y: auto;
`;

export const WorklistGroupStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  flexGrow: { sm: '1' },
})`
  overflow-y: auto;
`;

interface SearchCanvasButtonStyledProps {
  isDefaultFilterChange: boolean;
}
export const SearchCanvasButtonStyled = styled(Button)<SearchCanvasButtonStyledProps>`
  ${(props) =>
    props.isDefaultFilterChange &&
    css`
      background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      &:hover {
        background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      }
    `}
`;

export const SearchIconStyled = styled(Icon)`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    & > svg {
      height: ${({ theme }) => theme.fontSizes[500]};
    }
  }
`;

export const SearchFieldStyled = styled(Box).attrs({
  mr: { sm: '400' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
})`
  min-width: 250px; /* Setting min-width to show entire place holder text without cutting off. */
  ${IconStyled} {
    right: ${({ theme }) => theme.spacings[500]};
  }
  ${TextFieldStyled} {
    ${({ theme }) => css`
      font-size: ${theme.fontSizes[400]};
      border-color: ${theme.colors.grey[300]};
      font-family: 'Graphik';
    `}
  }
`;

//Wrapper element mainly used for passing data-testid and check existence of items
export const ContentStyled = styled.div`
  display: contents;
`;
